import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { TimezoneSelector } from 'components/timezoneSelector';
export const TimezoneModal = ({ timezone: propTimezone, onClose, onSubmit, }) => {
    const [timezone, setTimezone] = useState(propTimezone);
    return (_jsx(Modal, Object.assign({ isOpen: true, onClose: onClose }, { children: _jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { onClose: onClose, title: "Edit timezone" }), _jsx(ModalBody, { children: _jsx(TimezoneSelector, { placeholder: "Select the timezone for this schedule", required: true, input: {
                            name: 'timezone',
                            onChange: (value) => value && setTimezone(value),
                            value: timezone,
                        }, noAlert: true }) }), _jsx(ModalFoot, { cancelOnClick: onClose, confirmProps: { disabled: timezone === propTimezone }, confirmName: "Update", confirmOnClick: () => {
                        onSubmit(timezone);
                        onClose();
                    } })] })) })));
};
